import {DARK_THEME, DRAWER_TYPE, FIXED_DRAWER, THEME_COLOR, TOGGLE_COLLAPSED_NAV, SET_CLIENT_SETTINGS} from 'constants/ActionTypes';
import {DEEP_ORANGE} from "constants/ThemeColors";

const initialSettings = {
    navCollapsed: false,
    drawerType: FIXED_DRAWER,
    themeColor: DEEP_ORANGE,
    darkTheme: false,
    clientSettings: null
};

const settings = (state = initialSettings, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                navCollapsed: false
            };
        case TOGGLE_COLLAPSED_NAV:
            return {
                ...state,
                navCollapsed: action.isNavCollapsed
            };
        case DRAWER_TYPE:
            return {
                ...state,
                drawerType: action.drawerType
            };
        case THEME_COLOR:
            return {
                ...state,
                darkTheme: false,
                themeColor: action.color
            };
        case DARK_THEME:
            return {
                ...state,
                darkTheme: !state.darkTheme
            };
        case SET_CLIENT_SETTINGS:
            return {
                ...state,
                clientSettings: action.settings
            };
        default:
            return state;
    }
};

export default settings;



// WEBPACK FOOTER //
// ./reducers/Settings.js